import { BillingEmptyState } from '@/features/billing/components/BillingEmptyState'
import { Button } from '@/components/Button'

export interface PayoutMethodsEmptyStateProps {
  canAddPayoutMethod: boolean
  isAddPending: boolean
  onNewPayoutMethod: () => unknown
  corporateMode: boolean
}

export function PayoutMethodsEmptyState({
  canAddPayoutMethod,
  isAddPending,
  onNewPayoutMethod,
  corporateMode,
}: PayoutMethodsEmptyStateProps) {
  return (
    <BillingEmptyState
      corporateMode={corporateMode}
      title="There are no Payout Methods"
      subtitle="No payout methods have been set up."
    >
      {canAddPayoutMethod && (
        <Button
          label="Add New Payout Method"
          isDisabled={isAddPending}
          isPending={isAddPending}
          variant="primary"
          onPress={onNewPayoutMethod}
        />
      )}
    </BillingEmptyState>
  )
}
